import { lazy } from "react";

const routes = [
  {
    path: "/home",
    element: lazy(() => import("../pages/Home")),
  },
];

export default routes;
